import React from 'react';
import { ChatBubbleLeftEllipsisIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import Card from '../../components/Card';
import classNames from 'classnames';
import useDialogLauncher from '../../dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../dialogs_new/DialogManager';

export default function IntercomQuestion(props) {
  const { supportQuestion } = props;

  // const launch = useDialogLauncher();
  //
  // function onClick() {
  //   launch(DialogManager.SupportQuestionView.Config(supportQuestion.id));
  // }

  return (
    <Card className="overflow-hidden">
      <div id="custom_intercom_button" className={classNames(
        'hover:bg-cs-gray-50 cursor-pointer',
        'relative'
      )}>
        <div className="flex flex-col sm:flex-row p-4 space-x-0 sm:space-x-4 space-y-4 sm:space-y-0">
          <div className="flex flex-row sm:flex-col">
            <div className="p-2 bg-cs-orange-500 bg-opacity-10 rounded-lg relative">
              <ChatBubbleLeftEllipsisIcon className="h-8 w-8 text-cs-orange-500" />
            </div>
          </div>
          <div className="flex flex-1 text-cs-gray-900 pr-0 sm:pr-16 items-center">
            <div className="text-base font-semibold">
              How can I get help with a platform or website question or issue?
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
